import {Fragment} from 'react'
import {ANIMATION_DEFAULTS} from 'slices/AnimatedTextBlock/components/constants'

export const SpanComponent = ({text}: {text: string}) => {
  const tokens = text.split(/(\s+)/)
  const out: JSX.Element[] = []
  let key = 0

  for (const tok of tokens) {
    if (tok === '') {
      continue
    }

    if (tok === '\n' || tok === '\\n') {
      out.push(<br key={`br-${key++}`} />)
      continue
    }

    if (/^\s+$/.test(tok)) {
      out.push(<Fragment key={`w-${key++}`}>{tok}</Fragment>)
      continue
    }

    out.push(
      <span
        key={`word-${key++}`}
        data-word
        className={`
          inline-block
          whitespace-nowrap
          will-change-[opacity,filter]
          [.fx-ready_&]:transition-[opacity,filter]
          [.fx-ready_&]:duration-500
          [.fx-ready_&]:ease-linear`}
        style={{opacity: 0, filter: `blur(${ANIMATION_DEFAULTS.BLUR_MAX}px)`}}
      >
        {tok}
      </span>,
    )
  }

  return <>{out}</>
}
